import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=5b09abac&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=5b09abac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09abac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b09abac')) {
      api.createRecord('5b09abac', component.options)
    } else {
      api.reload('5b09abac', component.options)
    }
    module.hot.accept("./FormBuilder.vue?vue&type=template&id=5b09abac&scoped=true", function () {
      api.rerender('5b09abac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-builder/FormBuilder.vue"
export default component.exports